export default "__VITE_ASSET__Bi6Qet_8__"